/*
 * @Author: yingguanghui1 yingguanghui1@jd.com
 * @Date: 2025-07-17 10:20:55
 * @LastEditors: yingguanghui1 yingguanghui1@jd.com
 * @LastEditTime: 2025-07-23 17:20:15
 * @FilePath: /asset-web/src/router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
Vue.use(Router)
import rootApp from './App.vue'

const rootComponent = () => (window.__MICRO_APP_ENVIRONMENT__ || window.top !== window) ? rootApp : Home

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      redirect: 'assetList',
      component: rootComponent(),
      children: [{
          path: 'assetList',
          name: 'assetList',
          component: () => import('@/views/AssetList.vue')
        },
        {
          path: 'serviceProtocal/:type',
          props: true,
          name: 'serviceProtocal',
          component: () => import('@/views/ServiceProtocal.vue')
        },
        {
          path: 'eAccount',
          name: 'eAccount',
          component: () => import('@/views/EAccount.vue')
        },
        {
          path: 'flowAccount',
          name: 'flowAccount',
          component: () => import('@/views/FlowAccount.vue')
        },
        {
          path: 'redGiftAccount',
          name: 'redGiftAccount',
          component: () => import('@/views/RedGiftAccount.vue')
        },
        {
          path: 'aiqiyiAccount',
          name: 'aiqiyiAccount',
          component: () => import('@/views/AiqiyiAccount.vue')
        },
        {
          path: 'plusAccount',
          name: 'plusAccount',
          component: () => import('@/views/PlusAccount.vue')
        },
        {
          path: 'chitAccount',
          name: 'chitAccount',
          component: () => import('@/views/ChitAccount.vue')
        },
        {
          path: 'dongdongAccount',
          name: 'dongdongAccount',
          component: () => import('@/views/DongDongAccount.vue')
        },
        {
          path: "beanAccount",
          name: "beanAccount",
          component: () => import('@/views/BeanAccount.vue')
        },
        {
          path: "bankCardAccount",
          name: "bankCardAccount",
          component: () => import('@/views/bankCardAccount.vue')
        },
        {
          path: "myAccount",
          name: "myAccount",
          component: () => import('@/views/jingdou/MyAccount.vue')
        },
        {
          path: "JDPlan",
          name: "JDPlan",
          component: () => import('@/views/jingdou/JDPlan.vue')
        },{
           path: "assetTool",
           name: "assetTool",
           component: () => import('@/views/assetTool.vue')
        },{
          path: "activityMgr",
          name: "activityMgr",
          component: () => import('@/views/activityMgr/ActivityList.vue')
       }
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
